import React from "react"
import { useQuery } from "@apollo/client"
import { LoaderMedium } from "../../components/Loaders"

const withDataFetching = (WrappedComponent, query) => {
  return ({ variables, ...props }) => {
    const { data, loading, error } = useQuery(query, {
      variables,
      fetchPolicy: "network-only",
    })

    if (loading) return <LoaderMedium />
    if (error) return <div>Error loading data</div>

    return <WrappedComponent {...props} data={data} />
  }
}

export default withDataFetching
